import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TaskTemplate, deepCopy } from 'na-lib';
import { WorkTaskTemplateEditValueDialogComponent } from '../work-task-template-edit-value-dialog/work-task-template-edit-value-dialog.component';
import { SettingsService } from '../../service/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { WorkTaskTemplateDialogIncomingOutgoingComponent } from '../work-task-template-dialog-incoming-outgoing/work-task-template-dialog-incoming-outgoing.component';
import { WorkTaskTemplateWorkflowDialogComponent } from '../work-task-template-workflow-dialog/work-task-template-workflow-dialog.component';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'app-work-task-template-dialog',
    templateUrl: './work-task-template-dialog.component.html',
    styleUrls: ['./work-task-template-dialog.component.css'],
    standalone: false
})
export class WorkTaskTemplateDialogComponent implements OnInit, OnDestroy{
  workTaskTemplateForm!:FormGroup
  workTaskTemplateData: TaskTemplate
  userGroupList:any=[]
  allActionsTypes:any=[]
  allActionsNames:any=[]
  titleKeys:any=[]
  predicates:any=[]
  writeTag:any =""
  verifyTag:any =""
  taskTemplateGroups:any
  identify_p:any =""
  identify_face:any=""
  posibleActions:any=[]
  panelOpenState = false;
  allActions:any=[]
  contentTypesList:any=[]
  contentTypeSearchTerm = '';
  tasktemplateUserRights_update:any
  workflows:any[]=[]
  userHasBetaWidgetRole:boolean=false
  private contextChangeSubscription: Subscription
  private destroy$ = new Subject<void>();

  tridySelection = {
    "scan":{
      translation:'workTask.select_scan',
      value:'scan',
    },
    "select":{
      translation:'workTask.select_list',
      value:'select'
    },
    "opticalScan":{
      translation:'workTask.select_opticalScan',
      value:'opticalScan'
    },
    "scanQR":{
      translation:'workTask.select_scanQR',
      value:'scanQR'
    },
    "scanNFC":{
      translation:'workTask.select_scanNFC',
      value:'scanNFC'
    }
  }

  multiplicity = [
    {//"0-*":
      translation:"workTask.multiplicity.endless",
      value:'0-*',
    },
    {//"1-*":
      translation:"workTask.multiplicity.atLEast_once",
      value:'1-*'
    },
    {//"0-1":
      translation:"workTask.multiplicity.maxOne",
      value:"0-1"
    },
    {//"1-1":
      translation:"workTask.multiplicity.one",
      value:"1-1"
    },
    {//"":
      translation:"workTask.multiplicity.custom",
      value:""
    }
  ]

  constructor(
    public dialogRef: MatDialogRef<WorkTaskTemplateDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private settingsService : SettingsService,
    private translate:TranslateService
  ){
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {

    this.tasktemplateUserRights_update = this.settingsService.userRolesRights$['workTaskTemplates']['U']
    
    this.loadContentTypes();

    this.contextChangeSubscription = this.settingsService.contextIdChange$.subscribe(() => {
      this.loadContentTypes();
    });

    if(this.settingsService.checkIfBetaRoleAccess())
      this.userHasBetaWidgetRole = true

    this.posibleActions = [
      {
        name:"Write Tag" ,
        translate:"workTask.action_write_tag",
        added:false,
        value:"writeTag",
        pos:0,
        disabled:false
      },
      {
        name:"Verify Tag",
        translate:"workTask.action_verify_tag",
        added:false,
        value:"verifyTag",
        pos:1,
        disabled:false
      },
      {
        name:"Lock Tag",
        translate:"workTask.action_lock_tag",
        added:false,
        value:"lockTag",
        pos:2,
        disabled:false
      },
      {
        name:"Identify with FaceID",
        translate:"workTask.action_identify_faceId",
        added:false,
        value:"faceId",
        pos:3,
        disabled:false
      },
      ...(this.userHasBetaWidgetRole ? [{
        name:"Start Workflow",
        translate:"workTask.action_start_workflow",
        added:false,
        value:"startWorkflow",
        pos:4,
        disabled:false,
        isBeta:true
      }] : [])
    ]

    this.workTaskTemplateData = new TaskTemplate()
    this.workTaskTemplateData.setFromAny(this.data.values)
    this.taskTemplateGroups = this.data['groups']
    this.userGroupList = this.data['userGroups'] ?? []

    if(this.userHasBetaWidgetRole) {
      const contextId = this.settingsService.contextId$;
      this.settingsService.getWorkflowTemplates(contextId).pipe(takeUntil(this.destroy$)).subscribe(workflowTemplates => {
        this.workflows = workflowTemplates || []
      })
    }

    this.workTaskTemplateForm = this.fb.group({
      tridySource:[],
      contentType:[, Validators.required],
      visibleInPass:[],
      actions:[],
      titleKeys:[],
      predicates:[],
      createContent:[],
      incomingTridys:[],
      outgoingTridys:[],
      taskType:[, Validators.required],
      showImages:[],
      showComment:[],
      title:[, Validators.required],
      groupId:[],
      userGroupIds:[],
      hidden:[],
      gpsMandatory:[],
    })

    this.initializeActions()
    const {tridySource, contentType, visibleInPass, actions, titleKeys, predicates,incomingTridys,
      outgoingTridys,taskType,groupId,userGroupIds,showImages,showComment,title, hidden, gpsMandatory} = this.workTaskTemplateData

    if(!actions?.includes('writeTag'))
      this.disableLockTagIfNotWriteTag()
    else
    this.ableLockTagIfWriteTag()

    this.workTaskTemplateForm.patchValue({
      tridySource:tridySource ? tridySource : undefined,
      contentType: contentType ? contentType : undefined,
      visibleInPass:visibleInPass ? visibleInPass : false,
      actions:actions ? actions : undefined,
      titleKeys: titleKeys ? titleKeys : undefined,
      predicates: predicates ? predicates : undefined,
      createContent:undefined,
      incomingTridys : incomingTridys ? incomingTridys : undefined,
      outgoingTridys: outgoingTridys ? outgoingTridys :undefined,
      taskType: taskType ? taskType : undefined,
      groupId: groupId ? groupId : undefined,
      showImages:showImages,
      showComment:showComment,
      title: title ? title : undefined,
      hidden: hidden ? hidden : undefined,
      gpsMandatory: gpsMandatory ? gpsMandatory : undefined,
    })
    if(taskType && taskType=='transform'){
    }else{
      this.workTaskTemplateForm.controls["contentType"].setValidators([Validators.required]);
      this.workTaskTemplateForm.controls["contentType"].updateValueAndValidity();
    }

    this.workTaskTemplateForm.get('taskType')?.valueChanges.subscribe( value => {
      if(value=='transform'){
        this.disableAfterTransform()
      }else
        this.ableWhenNoTransform()
    })

    if(taskType=='transform'){
      this.disableAfterTransform()
    }

    if(showComment==undefined){
      this.workTaskTemplateForm.patchValue({
        showComment:true
      })
    }

    if(showImages==undefined){
      this.workTaskTemplateForm.patchValue({
        showImages:true
      })
    }

    if(this.workTaskTemplateForm.value.titleKeys){
      this.titleKeys = this.workTaskTemplateForm.value.titleKeys
    }

    if(this.workTaskTemplateForm.value.predicates){
      this.predicates = this.workTaskTemplateForm.value.predicates
      this.workTaskTemplateForm.patchValue({predicates: this.predicates})
    }

    this.userGroupList = this.data['userGroups'] ?? [];
    this.workTaskTemplateForm.patchValue({
      userGroupIds: userGroupIds ?? []
    });

    this.workTaskTemplateForm.get('actions')?.valueChanges.subscribe( value => {
      const actions = value || []
      if(!actions.includes('writeTag') && this.workTaskTemplateForm.get('taskType')?.value != "update"){
        this.disableLockTagIfNotWriteTag()
        const index = this.posibleActions.findIndex(pn => pn.value === 'lockTag')
        if(this.posibleActions[index]?.added)
          this.deleteAction(this.posibleActions[index], index)
      }
      else
        this.ableLockTagIfWriteTag()
    })

  }

  ableWhenNoTransform(){
    this.posibleActions.forEach(action => {
      action.disabled = false
    });
    this.workTaskTemplateForm.controls["contentType"].setValidators([Validators.required]);
    this.workTaskTemplateForm.controls["contentType"].updateValueAndValidity();
  }

  disableAfterTransform(){
    let actions = deepCopy(this.workTaskTemplateForm.value.actions)

    if(actions){
      this.posibleActions.forEach((action, index) => {
        action.added = false
        action.disabled = true
      });
    }
    this.workTaskTemplateForm.patchValue({actions: []})
    this.workTaskTemplateForm.controls["contentType"].removeValidators(Validators.required);
    this.workTaskTemplateForm.controls["contentType"].clearValidators();
    this.workTaskTemplateForm.controls["contentType"].updateValueAndValidity();
  }

  disableLockTagIfNotWriteTag(){
    const action = this.posibleActions.find( action => action.value === 'lockTag')
    action.disabled = true
  }

  ableLockTagIfWriteTag(){
    const action = this.posibleActions.find( action => action.value === 'lockTag')
    action.disabled = false
  }

  initializeActions(){

    if(this.workTaskTemplateData.actions){
      this.workTaskTemplateData.actions?.forEach((n:any, index) => {

        if( this.isWorkflowAction(n)){
            this.allActions.push(n)
            this.allActionsNames.push(n)
        }
        else{
          const action = this.posibleActions.find( actions => n === actions.value)
          if(action){
            action.added = true
            const tn= {
              name:action.name,
              value: n
            }

            this.allActions.push(tn)
            this.allActionsNames.push(tn.value)
          }

        }
      })
    }
  }

  onDone(){
    this.orderActions()
    if(this.workTaskTemplateForm.value.amountInteger){
      const amount = Math.trunc(this.workTaskTemplateForm.value.amount)
      this.workTaskTemplateForm.patchValue({amount: amount})
    }
    const newValues = this.workTaskTemplateForm.value
    this.dialogRef.close([newValues, true])
  }

  onCancel(){
    this.dialogRef.close([this.data, false])
  }

  addAction(name:string){
    const action = this.posibleActions.find((pa:any) => pa.name == name)
    if(action && action.value === 'startWorkflow'){
      this.openWorkflowDialog()
      return
    }

    const n={
      name:name,
      value:""
    }

    if(action && !action.added){
      action.added=true
      n.value = action.value
      this.allActions.push(n)
      this.posibleActions.sort((a,b) => a.pos - b.pos); // b - a for reverse sort
      this.allActionsNames.push(n.value)
      this.workTaskTemplateForm.patchValue({
        actions:this.allActionsNames
      })
    }
  }

  openWorkflowDialog(workflowAction?: any){
    if(this.tasktemplateUserRights_update){
      let dialogRef = this.dialog.open(WorkTaskTemplateWorkflowDialogComponent, {
        data: {
          workflowAction: workflowAction || null
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result && result[1]){
          const newWorkflowAction = result[0]
          if(workflowAction){
            const index = this.allActions.findIndex((action:any) =>
              this.isWorkflowAction(action) &&
              action.parameters?.workflowTemplateId === workflowAction.parameters?.workflowTemplateId
            )
            if(index !== -1){
              this.allActions[index] = newWorkflowAction
              this.allActionsNames[index] = newWorkflowAction
              this.workTaskTemplateForm.patchValue({
                actions:this.allActionsNames
              })
            }
          } else {
            this.allActions.push(newWorkflowAction)
            this.allActionsNames.push(newWorkflowAction)
            this.workTaskTemplateForm.patchValue({
              actions:this.allActionsNames
            })
          }
        }
      });
    }
  }

  orderActions(){
    let orderActions = []
    const actionsAll = deepCopy(this.workTaskTemplateForm.value.actions || [])
    this.posibleActions.forEach( actions => {
      if(actionsAll.includes(actions.value)){
        orderActions.push(actions.value)
      }
    })

    actionsAll.forEach(action => {
      // Handle object-based actions (like startWorkflow)
      if(this.isWorkflowAction(action)){
        orderActions.push(action)
      } else {
        const inactions = this.posibleActions.find(posible_action => posible_action.value == action)
        if(!inactions){
          orderActions.push(action)
        }
      }
    });
    this.workTaskTemplateForm.patchValue({actions: orderActions})
  }

  deleteAction(action:any, index:number){
    if(this.tasktemplateUserRights_update){
      this.posibleActions.forEach((pn:any)=> {
        if(pn==action){
          pn.added=false
          this.allActions.forEach((a:any, i:any)=>{
              this.allActions.splice(i,1)
          })

          this.allActionsNames.forEach( (a:any, ind:any) =>{
              this.allActionsNames.splice(ind,1)
          })
        }
      })
      this.workTaskTemplateForm.patchValue({
        actions:this.allActionsNames
      })
    }
  }

  editWorkflowAction(workflowAction: any){
    this.openWorkflowDialog(workflowAction)
  }

  deleteWorkflowAction(workflowAction: any, index: number){
    if(this.tasktemplateUserRights_update){
      const actionIndex = this.allActions.findIndex((action:any) =>
        this.isWorkflowAction(action) &&
        action.parameters?.workflowTemplateId === workflowAction.parameters?.workflowTemplateId
      )
      if(actionIndex !== -1){
        this.allActions.splice(actionIndex, 1)
      }

      const nameIndex = this.allActionsNames.findIndex((action:any) =>
        this.isWorkflowAction(action) &&
        action.parameters?.workflowTemplateId === workflowAction.parameters?.workflowTemplateId
      )
      if(nameIndex !== -1){
        this.allActionsNames.splice(nameIndex, 1)
      }

      this.workTaskTemplateForm.patchValue({
        actions:this.allActionsNames
      })
    }
  }

  getWorkflowActionDisplayName(workflowAction: any): string {
    if(this.isWorkflowAction(workflowAction)){
      const workflow = this.workflows.find(w => w.id === workflowAction.parameters?.workflowTemplateId)
      if(workflow){
        return workflow.name
      }
      return this.translate.instant('workTask.action_start_workflow')
    }
    return ''
  }

  isWorkflowAction(action: any): boolean {
    return typeof action === 'object' && action.action === 'startWorkflow'
  }

  deleteTitleKey(titleKey, index){
    if(this.tasktemplateUserRights_update){
      this.titleKeys.splice(index,1)
      this.workTaskTemplateForm.patchValue({titleKeys:this.titleKeys})
    }
  }

  addTitleKey(){
    const value = "new"
    this.titleKeys.push(value)
    this.workTaskTemplateForm.patchValue({titleKeys:this.titleKeys})
  }

  updateTitleKey(s, index){
    if(this.tasktemplateUserRights_update){
      let dialogRef = this.dialog.open(WorkTaskTemplateEditValueDialogComponent, {
        data: {
          value: s,
          type:'Title Key'
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          this.titleKeys[index] = result[0].value

        }
      });
    }
  }

  addIncomingTridys(){
    if(this.tasktemplateUserRights_update){
      let dialogRef = this.dialog.open(WorkTaskTemplateDialogIncomingOutgoingComponent, {
        data: {
          values:'',
          function: 'new',
          type:'Incoming',
          fields:['actions', 'contentTypeId', 'displayTitle', 'multiplicity', 'source'],
          contentTypes: this.contentTypesList
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          let incomingTridys = deepCopy(this.workTaskTemplateForm.value.incomingTridys)
          if(!incomingTridys)
            incomingTridys = []
          incomingTridys.push(result[0])
          this.workTaskTemplateForm.patchValue({incomingTridys:incomingTridys})
        }
      });
    }
  }

  openIncomingTridy(incoming, index){
    if(this.tasktemplateUserRights_update){
      let dialogRef = this.dialog.open(WorkTaskTemplateDialogIncomingOutgoingComponent, {
        data: {
          values:incoming,
          function: 'update',
          type:'Incoming',
          fields:['actions', 'contentTypeId', 'displayTitle', 'multiplicity', 'source'],
          contentTypes: this.contentTypesList
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          const incomingTridys = deepCopy(this.workTaskTemplateForm.value.incomingTridys)
          incomingTridys[index] = result[0]
          this.workTaskTemplateForm.patchValue({incomingTridys:incomingTridys})
        }
      });
    }
  }

  addOutgoingTridys(){
    if(this.tasktemplateUserRights_update){
      let dialogRef = this.dialog.open(WorkTaskTemplateDialogIncomingOutgoingComponent, {
        data: {
          values:'',
          function: 'new',
          type:'Outgoing',
          fields:['actions', 'contentTypeId', 'displayTitle', 'multiplicity', 'source'],
          contentTypes: this.contentTypesList
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          let outgoingTridys = deepCopy(this.workTaskTemplateForm.value.outgoingTridys)
          if(!outgoingTridys)
            outgoingTridys = []
          outgoingTridys.push(result[0])
          this.workTaskTemplateForm.patchValue({outgoingTridys:outgoingTridys})
        }
      });
    }
  }

  openOutgoingTridy(outgoing, index){
    if(this.tasktemplateUserRights_update){
      let dialogRef = this.dialog.open(WorkTaskTemplateDialogIncomingOutgoingComponent, {
        data: {
          values:outgoing,
          function: 'update',
          type:'Outgoing',
          fields:['actions', 'contentTypeId', 'displayTitle', 'multiplicity', 'source'],
          contentTypes: this.contentTypesList
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          const outgoingTridys = deepCopy(this.workTaskTemplateForm.value.outgoingTridys)
          outgoingTridys[index] = result[0]
          this.workTaskTemplateForm.patchValue({outgoingTridys:outgoingTridys})
        }
      });
    }
  }

  deleteIncomingTridy(outgoing, index){
    if(this.tasktemplateUserRights_update){
      const incomingTridys = deepCopy(this.workTaskTemplateForm.value.incomingTridys)
      incomingTridys.splice(index,1)
      this.workTaskTemplateForm.patchValue( {incomingTridys:incomingTridys})
    }
  }
  deleteOutgoingTridy(outgoing, index){
    if(this.tasktemplateUserRights_update){
      const outgoingTridys = deepCopy(this.workTaskTemplateForm.value.outgoingTridys)
      outgoingTridys.splice(index,1)
      this.workTaskTemplateForm.patchValue( {outgoingTridys:outgoingTridys})
    }
  }

  getContentTypeIdName(id){
    const content = this.contentTypesList?.find( contentType => contentType.id == id )
    if(content)
    return content.displayName
  }

  getTridyMultiplicity(multiplicity){
    let translation
    const multipli = this.multiplicity.find( option => option.value == multiplicity )
    if(multipli)
    translation = this.translate.instant(multipli.translation)
    else{
      const values = multiplicity.split('-')
      translation = values[0] + ' to ' + values[1]
    }
    return translation
  }

  getTridyAction(actions: string[]): string | undefined {
    if (actions && actions.length > 0) {
      // Define the possible translations based on action values
      const actionTranslations = {
        writeTag: 'workTask.action_new_tag',
        readTag: 'workTask.action_scan_existing_tag',
        readTagQR: 'workTask.action_scan_existing_QR'
      };

      return actions
        .map(action => actionTranslations[action] ? actionTranslations[action] : '')
        .filter(Boolean)
        .map(translationKey => this.translate.instant(translationKey))
        .join(', ');
    }
    return undefined;
  }

  getTridySelection(incoming){
    let all = ''
    if(incoming){
      if(incoming.source && !incoming.sources){
        const source = incoming.source
        if(this.tridySelection[source]){
          const message = this.translate.instant(this.tridySelection[source].translation)
          all += '-'+message + ' '
        }
      }

      if(incoming.sources){
        incoming.sources.forEach( source => {
          if(this.tridySelection[source]){
            const message = this.translate.instant(this.tridySelection[source].translation)
            all += '-'+message + ' '
          }
        })
      }
    }
    return all
  }

  loadContentTypes(): void {
    this.settingsService.observeContextsContentTypesFirestoreWithId(this.settingsService.contextId$).subscribe(contentTypes => {
      this.contentTypesList = contentTypes?.sort((a: any, b: any) =>
        a?.displayName?.toLowerCase().localeCompare(b?.displayName?.toLowerCase())
      );
    });
  }

  get filteredContentTypesList(): any[] {
    const term = this.contentTypeSearchTerm.trim().toLowerCase();
    if (!term) return this.contentTypesList || [];
    return (this.contentTypesList || []).filter((contentType: any) =>
      String(contentType?.displayName || '').toLowerCase().includes(term)
        || String(contentType?.id || '').toLowerCase().includes(term)
    );
  }

  ngOnDestroy(): void {
    if (this.contextChangeSubscription) {
      this.contextChangeSubscription.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }
}
